import type {FormResponse} from 'src/api/ProactApiClient';
import {createForm} from './api';
import {isEffectivelyOffline} from 'src/offline/connectivity';
import {offlineMutation} from 'src/offline/offlineMutation';
import {
  enqueuePendingFormUploads,
  hasPendingFormUploads,
} from './localFiles';
import type {OfflineFormCreateRequest} from './queuedTransition';
import {stripQueuedTransition} from './queuedTransition';
import {FORMS_CONTEXT_KEY} from './snapshotKeys';

// Prepared create-form `queryFn`: diverts to the outbox only when offline, or
// when the payload carries outbox-only offline-captured attachments.
export const createFormMutationFn = offlineMutation<
  OfflineFormCreateRequest,
  FormResponse
>(
  'form.create',
  request => createForm(stripQueuedTransition(request)),
  {
    contextKey: () => FORMS_CONTEXT_KEY,
    shouldDivert: request =>
      isEffectivelyOffline() ||
      hasPendingFormUploads(request.targetFieldValues ?? []),
    // Queued in the create's transaction so uploads and the create commit together.
    applyLocal: (request, ctx) =>
      enqueuePendingFormUploads(ctx.sessionId, request.targetFieldValues ?? []),
  }
);
